module.exports = __webpack_public_path__ + "static/media/trading.0de8d581.mp4";